<div class="validation-summary">
  <mat-icon [class.status-green]="allHaveLabelData" [class.status-red]="!allHaveLabelData">
    {{ allHaveLabelData ? 'check_circle' : 'error' }}
  </mat-icon>
  <span class="summary-text" [class.status-green]="allHaveLabelData" [class.status-red]="!allHaveLabelData">
    {{ productsWithLabelData }}/{{ products.length }} products have product label data
  </span>
  <span class="spacer"></span>
  <button mat-stroked-button class="collapse-btn" (click)="anyExpanded ? collapseAll() : expandAll()">
    {{ anyExpanded ? 'Collapse All' : 'Expand All' }}
  </button>
</div>

<div class="product-list">
  @for (product of products; track product) {
    <div class="product-row">
      <div class="product-header"
        [class.clickable]="product.productLabelDataGenerated"
        [class.blocked]="isBlocked(product)"
        (click)="product.productLabelDataGenerated ? toggleProduct(product) : null">
        <mat-icon class="expand-icon" [class.placeholder-icon]="!product.productLabelDataGenerated">
          {{ !product.productLabelDataGenerated ? 'remove' : isProductExpanded(product.id!) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        <mat-icon class="status-icon"
          [class.status-green]="product.productLabelDataGenerated && !isBlocked(product)"
          [class.status-red]="!product.productLabelDataGenerated || isBlocked(product)">
          {{ product.productLabelDataGenerated && !isBlocked(product) ? 'check_circle' : 'warning' }}
        </mat-icon>
        @if (isBlocked(product)) {
          <span class="blocked-msg">{{ blockedIdentifierLabel() }} is missing</span>
        } @else {
          <span class="product-name"
            [class.status-green]="product.productLabelDataGenerated"
            [class.status-red]="!product.productLabelDataGenerated">
            @if (filenameIdentifier == null) {
              {{ product.barcode || product.id }}
            } @else if (resolvedFilenameBase(product); as base) {
              {{ base }}
            } @else {
              {{ product.barcode || product.id }}
            }
          </span>
        }
        <span class="spacer"></span>
        @if (!product.productLabelDataGenerated) {
          <span class="no-label-text">No product label data</span>
        }
        @if (product.productLabelDataGenerated && product.lastProductLabelDataGeneratedAt) {
          <span class="generated-at-text">
            {{ product.lastProductLabelDataGeneratedAt | date:'short' }}
          </span>
        }
        @if (isBlocked(product)) {
          <button
            type="button"
            class="edit-product-btn"
            (click)="$event.stopPropagation(); openEditProduct(product)">
            Edit product
          </button>
        }
        <app-product-identifiers-popover
          [product]="product"
          [pdfcIdentifier]="filenameIdentifier"
          [mode]="isBlocked(product) ? 'block' : 'info'"
          (click)="$event.stopPropagation()"
          (editRequested)="openEditProduct($event)">
        </app-product-identifiers-popover>
      </div>
      @if (isProductExpanded(product.id!)) {
        <div class="product-preview-body">
          @if (isPreviewLoading(product.id!)) {
            <div class="preview-loading">
              <mat-spinner diameter="24"></mat-spinner>
            </div>
          }
          @if (isPreviewError(product.id!)) {
            <div class="preview-error">
              <mat-icon class="status-red">warning</mat-icon>
              <span>Failed to load preview</span>
              <a href="javascript:void(0)" class="retry-link" (click)="retryPreview(product)">Retry</a>
            </div>
          }
          @if (resolvedPreview(product.id!); as previewed) {
            @for (file of previewed.files; track file.filename) {
              <details class="file-preview" open>
                <summary class="file-preview-header">
                  <mat-icon class="file-icon">description</mat-icon>
                  <span class="filename">{{ file.filename }}</span>
                  <span class="sample-tag">Preview</span>
                </summary>
                @if (file.contentType === 'application/json') {
                  <pre>{{ file.content }}</pre>
                }
                @if (file.contentType === 'text/csv') {
                  <ng-container
                    [ngTemplateOutlet]="csvTable"
                    [ngTemplateOutletContext]="{$implicit: parseCsvContent(file.content)}">
                  </ng-container>
                }
              </details>
            }
          }
        </div>
      }
    </div>
  }
</div>

<ng-template #csvTable let-parsed>
  <table class="csv-preview">
    <thead>
      <tr>
        @for (header of parsed.headers; track header) {
          <th>{{ header }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of parsed.rows; track $index) {
        <tr>
          @for (cell of row; track $index) {
            <td>{{ cell }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</ng-template>
